import React, { useState } from 'react';
import { Modal, Row, Col, Button, Space, message } from 'antd';
import { SaveOutlined, PlusOutlined } from '@ant-design/icons';
import EndpointTable from './EndpointTable';
import TrafficDistribution from './TrafficDistribution';
import AddEndpointModal from './AddEndpointModal';

const EndpointManagementModal = ({ 
  visible, 
  domain, 
  loading, 
  endpoints, 
  onCancel, 
  onWeightChange,
  onSave 
}) => {
    const [isAddEndpointModalVisible, setIsAddEndpointModalVisible] = useState(false);
    const [addEndpointLoading, setAddEndpointLoading] = useState(false);

    const handleAddEndpointClick = () => {
        setIsAddEndpointModalVisible(true);
    };
    
    const handleAddEndpointCancel = () => {
        setIsAddEndpointModalVisible(false);
    };
    
    const handleAddEndpoint = async (values) => {
        setAddEndpointLoading(true);
        try {
        // 這裡添加創建端點的 API 調用
        await new Promise(resolve => setTimeout(resolve, 1000));
        message.success('Endpoint added successfully');
        setIsAddEndpointModalVisible(false);
        } catch (error) {
        message.error('Failed to add endpoint');
        } finally {
        setAddEndpointLoading(false);
        }
    };

    return (
        <Modal
        title={domain ? `Endpoint Management - ${domain.domain}` : 'Endpoint Management'}
        visible={visible}
        onCancel={onCancel}
        width={'80%'}
        footer={null}
        destroyOnClose
        className="endpoint-management-modal"
        >
        <div className="modal-content">
            <Row gutter={[16, 16]}>
            <Col span={24}>
                <div className="modal-toolbar">
                <Space>
                    <Button 
                    type="primary" 
                    icon={<PlusOutlined />}
                    onClick={handleAddEndpointClick}
                    >
                    Add Endpoint
                    </Button>
                    <Button 
                    type="primary"
                    icon={<SaveOutlined />}
                    onClick={onSave}
                    >
                    Save Changes
                    </Button>
                </Space>
                </div>
            </Col>
            </Row>

            <Row gutter={[16, 16]}>
            <Col span={16}>
                <EndpointTable 
                loading={loading}
                endpoints={endpoints}
                onWeightChange={onWeightChange}
                />
            </Col>
            <Col span={8}>
                <div className="distribution-chart">
                <h3>Traffic Distribution</h3>
                <TrafficDistribution 
                    loading={loading}
                    endpoints={endpoints}
                />
                </div>
            </Col>
            </Row>
        </div>

        <AddEndpointModal
            visible={isAddEndpointModalVisible}
            loading={addEndpointLoading}
            onCancel={handleAddEndpointCancel}
            onAdd={handleAddEndpoint}
        />
        </Modal>
    );
};

export default EndpointManagementModal;
